import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=016d4a3c&scoped=true&"
import script from "./Messages.vue?vue&type=script&lang=js&"
export * from "./Messages.vue?vue&type=script&lang=js&"
import style0 from "./Messages.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Messages.vue?vue&type=style&index=1&id=016d4a3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016d4a3c",
  null
  
)

export default component.exports